import { render, staticRenderFns } from "./InsightCarousel.vue?vue&type=template&id=6b068df2&"
import script from "./InsightCarousel.vue?vue&type=script&lang=ts&"
export * from "./InsightCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./InsightCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports